import type { HttpClient } from '@shared/api/httpClient';
import type { ApiRecord } from './packageUi';
import { packageId } from './packageUi';

export type PackageReportPreviewResponse = {
  previewUrl: string;
  expiresInSeconds?: number;
  packageId?: string;
  fileName?: string;
};

export async function requestPackageReportPreviewUrl(
  api: HttpClient,
  pkg: ApiRecord,
): Promise<PackageReportPreviewResponse> {
  const id = packageId(pkg);
  if (!id) throw new Error('Package ID is required to preview the report.');

  const response = await api.post<PackageReportPreviewResponse>(
    `/client/packages/${encodeURIComponent(id)}/report-preview-url`,
    {},
  );
  if (!response.previewUrl) throw new Error('The API did not return a report preview URL.');
  return response;
}
